export default "__VITE_ASSET__GAL$u8Oz__"